import api from './api';
import { ApiResponse, DatasetWithCount } from '../types';

export type DatasetType = 'mmc' | 'plate' | 'detection';

/**
 * List all datasets with their sample counts
 * GET /datasets/list/{type}
 */
export async function listDatasets(type: DatasetType): Promise<DatasetWithCount[]> {
  const response = await api.get<ApiResponse<DatasetWithCount[]>>(`datasets/list/${type}`);
  return response.data.results || [];
}

/**
 * Create a new dataset
 * POST /datasets/create/{type}
 */
export async function createDataset(
  type: DatasetType,
  label: string
): Promise<{ id: string }> {
  const response = await api.post<ApiResponse<{ id: string }>>(`datasets/create/${type}`, { label });
  return response.data.results;
}

/**
 * Rename an existing dataset
 * PATCH /datasets/patch/{type}/{id}
 */
export async function renameDataset(
  type: DatasetType,
  datasetId: string,
  label: string
): Promise<void> {
  await api.patch(`datasets/patch/${type}/${datasetId}`, { label });
}

/**
 * Delete a dataset (only if no samples attached)
 * DELETE /datasets/delete/{type}/{id}
 */
export async function deleteDataset(type: DatasetType, datasetId: string): Promise<void> {
  await api.delete(`datasets/delete/${type}/${datasetId}`);
}
